/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Umleitung`
};

const en_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Bypass`
};

const es_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Bypass`
};

const fr_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Déviation`
};

const it_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Bypass`
};

const nl_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Omleiding`
};

const pt_alert_itinerary__closed_roads__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Bypass`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const alert_itinerary__closed_roads__cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.alert_itinerary__closed_roads__cta(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("alert_itinerary__closed_roads__cta", locale)
	if (locale === "de") return de_alert_itinerary__closed_roads__cta(inputs)
	if (locale === "en") return en_alert_itinerary__closed_roads__cta(inputs)
	if (locale === "es") return es_alert_itinerary__closed_roads__cta(inputs)
	if (locale === "fr") return fr_alert_itinerary__closed_roads__cta(inputs)
	if (locale === "it") return it_alert_itinerary__closed_roads__cta(inputs)
	if (locale === "nl") return nl_alert_itinerary__closed_roads__cta(inputs)
	return pt_alert_itinerary__closed_roads__cta(inputs)
};